import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import TextField from '@mui/material/TextField';
import TableHead from '@mui/material/TableHead';
import Button from '@mui/material/Button';
import { findUsers, getUsuarioSala, findUsersAll } from "./api-mensagem";
import { useNavigate } from 'react-router-dom';

import { RESPONSAVEL, ALUNO } from '../Usuario/Perfil';
import { useSelector } from 'react-redux';
import Loading from '../UI/Loading';


const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    formulario: {
        marginBottom: '20px'
    }
});


export default function MensagemFind() {
    const classes = useStyles();
    const usuario = useSelector(state => state.usuario);
    const [search, setSearch] = useState();
    const [usuarios, setUsuarios] = useState([]);
    const history = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (usuario && (usuario.perfil === RESPONSAVEL || usuario.perfil === ALUNO)) {
            setIsLoading(true);
            findUsersAll().then((data) => {
                if (data.error) {
                    console.log(data);
                } else {
                    setUsuarios(data);
                    setIsLoading(false);
                }
            })
        }
    }, [usuario]);

    const handleChange = (event) => {
        setSearch(event.target.value);
    }

    const clickSubmit = (event) => {
        event.preventDefault();
        findUsers(search).then((data) => {
            if (data) {
                setUsuarios(data);
            }
        });
    }

    const handleSelectedUser = (usuario) => {
        getUsuarioSala(usuario.id).then((data) => {
            if (data) {
                history('/sala-mensagem', { state: { sala: data } })
            }
        })
    }

    return (
        <>
            {isLoading ?
                <Loading description='Carregando Contatos...' />
                :
                <>
                    {usuario && usuario.perfil !== RESPONSAVEL && usuario.perfil !== ALUNO ?
                        <form className={classes.formulario} onSubmit={clickSubmit}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                label="Nome"
                                name="nome"
                                onChange={handleChange}
                                value={search ? search : ''}
                                slotProps={{
                                    htmlInput: { maxLength: 60 }
                                }}
                            />
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={classes.submit}>
                                Buscar
                            </Button>
                        </form> : ''}

                    <Table className={classes.table} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Nome</TableCell>
                                <TableCell>Perfil</TableCell>
                                <TableCell>Ações</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {usuarios.map((usuario, index) => (
                                <TableRow
                                    key={index}
                                >
                                    <TableCell>
                                        {usuario && usuario.nome ? usuario.nome : ''}
                                    </TableCell>
                                    <TableCell>
                                        {usuario && usuario.perfil ? usuario.perfil : ''}
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            className={classes.submit}
                                            onClick={() => handleSelectedUser(usuario)}
                                        >
                                            Selecionar
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </>

            }
        </>
    );
}